exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p.text-justify {\n  font-size: smaller;\n}\np.text-left {\n  font-size: smaller;\n}\np.font-weight-bold {\n  font-weight: bold;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/careers/job-adv/job-adv.component.css
// module id = 193
// module chunks = 1